export default "__VITE_ASSET__B5Nwsnog__"